<template>
  <div class="context-menu"
       :style="getContextMenyStyle()">
    <ul>
      <li @click="handleDel">删除</li>
      <li @click="minifyCharts('left')">最小化至左边</li>
      <li @click="minifyCharts('right')">最小化至右边</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ContextMenu',
  data () {
    return {};
  },
  methods: {
    getContextMenyStyle () {
      let { isOpen, position } = this.$store.state.ContextMenu;
      return {
        display: isOpen ? 'block' : 'none',
        top: position.top + 'px',
        left: position.left + 'px',
      };
    },
    handleMouseUp () {
      this.$store.commit('set_ContextMenu', {
        isOpen: false,
      });
    },
    handleDel (){
      this.$store.commit('del_Charts', this.$store.state.CurrentConfigration.id);
    },
    minifyCharts (pos) {
      this.$store.commit('set_chartsShowStatus', {
        id: this.$store.state.CurrentConfigration.id,
        status: `minify-${pos}`,
      });
    },
  },
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.context-menu {
  user-select: none;
  position: fixed;
  left: 0;
  top: 0;

  font-size: 12px;
  color: #fff;
  width: 120px;

  padding-bottom: 20px;
  background-color: #27343e;
  z-index: 999;
  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
  }
  li {
    height: 25px;
    line-height: 25px;
    padding-left: 10px;
    box-sizing: border-box;
    cursor: pointer;
    border-left: 3px solid rgba(204, 204, 204, 0);
    letter-spacing: 1px;
    &:hover {
      background-color: #1b262f;
      color: rgb(0, 140, 255);
      border-left: 3px solid rgb(0, 140, 255);
    }
  }
}
</style>
